<Navbar/>
<div class="row mt-3">
    <div class="col-md-4 d-none d-lg-block">
       <button
      class="btn btn-primary btn-sm me-3"
      @click="$router.go(-1)"
    >
      <i class="bi bi-arrow-left"></i>
    </button>
      <p class="mx-2">{{current_date}}</p>
    </div>
    <div class="col-12 col-sm-12 col-md-4 text-lg-center">
      <button
      class="btn btn-primary btn-sm me-3 d-lg-none"
      @click="$router.go(-1)"
    >
      <i class="bi bi-arrow-left"></i>
    </button>
       <h3 class="underline-heading mx-2">{{$route.params.portal_name}}.</h3>
    </div>
    <div class="col-6 col-sm-6 col-md-4 d-none d-lg-block">
    </div>

</div>

<!-- Tab Contents -->
<div class="tab-content mt-3">
  <!-- Your Feed -->
  <div v-if="activeVoiceTab === 'your_feed'">
    <div class="row mt-2 px-2">
      <div class="col-md-12 mb-2 px-2 px-lg-5" v-for="report in reports">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex flex-wrap gap-1">
  <div
  v-for="category in filteredCategoriesForReport(report)"
  :key="category.name"
  class="d-flex align-items-center flex-wrap mb-1"
>
  <div class="fw-bold text-capitalize me-1">
    {{ category.name }}:
  </div>
  <span
    v-for="(tag, i) in category.tags"
    :key="tag.id"
    class="text-primary text-capitalize me-1"
  >
    {{ tag.name }}<span v-if="i < category.tags.length - 1">,</span>
  </span>
</div>

</div>
          <div>

          </div>
         </div> 
         <div class="px-0 px-lg-5">
           <div
                            v-for="(fileObj, index) in report.report_files"
                            :key="index"
                            class="mb-3"
                          >
                          <div class="media-container mb-3">

                            <img
                              v-if="fileObj?.file?.url &&
                                    (fileObj.file.url.includes('.jpg') ||
                                    fileObj.file.url.includes('.JPG') ||
                                    fileObj.file.url.includes('.png') ||
                                    fileObj.file.url.includes('.PNG') ||
                                    fileObj.file.url.includes('.avif') ||
                                    fileObj.file.url.includes('.AVIF') ||
                                    fileObj.file.url.includes('.jpeg') ||
                                    fileObj.file.url.includes('.JPEG') ||
                                    fileObj.file.url.includes('.webp') ||
                                    fileObj.file.url.includes('.WEBP'))"
                              :src="fileObj.file.url"
                              loading="lazy"
                              alt="Feed Image"
                              class="media-item rounded-5"
                            />


                            <audio
                              v-else-if="fileObj?.file?.url &&
                                        (fileObj.file.url.includes('.mp3') ||
                                          fileObj.file.url.includes('.wav'))"
                              controls
                              class="w-100"
                            >
                              <source :src="fileObj.file.url" type="audio/mp3" />
                              Your browser does not support the audio element.
                            </audio>


                            <video
                              v-else-if="fileObj?.file?.url &&
                                        /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)"
                              controls
                              class="media-item rounded-5"
                            >
                              <source :src="fileObj.file.url" />
                              Your browser does not support the video tag.
                            </video>



                            <div
                              v-else
                              class="uploaded-file"
                            >
                              <img
                                :src="getFileIcon(fileObj?.file?.url)"
                                loading="lazy"
                                class="file-icon small-icon"
                              />
                              <span class="file-name">
                                {{ getFileName(fileObj?.file?.url) }}
                              </span>
                              <a
                                :href="fileObj?.file?.url"
                                download
                                :title="getFileName(fileObj?.file?.url)"
                                class="download-btn"
                                @click.stop
                              >
                                <img
                                  src="https://cdn-icons-png.flaticon.com/128/724/724933.png"
                                  class="download-icon"
                                />
                              </a>
                            </div>
                          </div>
                      </div>
           <p v-html="report.description" class="text-xs mt-3"></p>

            <div class="d-flex justify-content-between align-items-center ">
                    <div class="mb-3 ms-2 me-3 mt-1">
                      <span class="d-flex color-purple " :id="'like-button' + report.id"
                        @click.stop="likeReport(report)"><i class="bi bi-hand-thumbs-up fw-bold"></i><span
                          class="text-purple text-xs mt-1 mx-1">Like</span></span>
                      <span :id="'liked-button' + report.id" class="d-none d-flex text-primary "
                        @click.stop="unlikeReport(report)"><i class="bi bi-hand-thumbs-up-fill"></i><span
                          class="text-primary text-xs mt-1 mx-1">Unlike</span> </span>
                    </div>

                    <div class="input-group mb-3 me-2 rounded-5 w-100 position-relative mt-1"
          >

                      <input type="text" class="form-control text-xs rounded-start rounded-end" @click="activeCommentReportId = report.id"
                        placeholder="Write a comment .." readonly>
                    </div>

                      <div class="mb-3 me-2 menu mt-1" @click.stop>
                      <input type="checkbox" :id="'menu-open-' + report.id" class="menu-open" name="menu-open" />
                      <span><label :for="'menu-open-' + report.id" class="menu-open-button text-xs color-purple d-flex"
                          @click="boon"><i class="bi bi-share"></i><span
                            class="color-purple mx-1 ">Share</span></label></span>

                      <a @click="copyReportLinkToClipboard(report)" class="menu-item bg-white">
                        <span @click="closeMenu(report.id)"><i
                            class="bi bi-link fs-4 copy text-primary text-xxs"></i></span>
                      </a>

                      <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item facebook-share-btn bg-white" @click="closeMenu(report.id)">
                        <i class="bi bi-facebook"></i>
                      </a>
                      <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item twitter-share-btn bg-white" @click="closeMenu(report.id)">
                        <i class="bi bi-twitter-x"></i>
                      </a>
                      <a :href="'mailto:?subject=Check%20this%20out&body=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item gmail-share-btn bg-white" @click="closeMenu(report.id)">
                        <i class="bi bi-google"></i>
                      </a>
                      <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item linkedin-share-btn bg-white" @click="closeMenu(report.id)">
                        <i class="bi bi-linkedin "></i>
                      </a>
                      <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item whatsapp-share-btn bg-white" @click="closeMenu(report.id)">
                        <i class="bi bi-whatsapp "></i>
                      </a>
                      <a :href="'https://t.me/share/url?url=' + encodeURIComponent(baseUrl(report,'report'))"
                        target="_blank" class="menu-item telegram-share-btn bg-white" @click="closeMenu(report.id)">
                        <i class="bi bi-telegram "></i>
                      </a>

                      <div aria-live="polite" aria-atomic="true" class="position-fixed custom-toast">
                        <div id="copyToast" class="toast align-items-center text-bg-success border-0" role="alert"
                          aria-live="assertive" aria-atomic="true">
                          <div class="d-flex">
                            <div class="toast-body">
                            </div>
                            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                              aria-label="Close"></button>
                          </div>
                        </div>
                      </div>

                    </div>
              </div>
                 <div class="d-flex align-items-center border rounded-pill mb-3 p-0" v-if="activeCommentReportId === report.id">
                    <img src="@/assets/images/user.png" alt="User" class="rounded-circle mx-2" width="32" height="32">
                    <input type="text" class="form-control border-0 rounded-5" id="comment_text_area" v-model="commentText" placeholder="Write a comment" aria-label="Recipient's username" aria-describedby="button-addon2">
                    <div class="d-flex align-items-center">
                      <button class="btn btn-sm text-xxs" type="button" id="button-addon2"  @click="submit_comment(report.id)"><i class="bi bi-send fs-5"></i></button>
                    </div>
                  </div>
            <!-- Comments Component -->
               <Comments
                :comments="report.comments"
                :report-id="report.id"
                @add-comment="handleAddComment"
              />
         </div>
            
         <div>
         </div>
      </div>
    </div>
  </div>

  <!-- Voice Tab -->
  <div v-if="activeVoiceTab === 'voice'">
    <SurveyView/>
  </div>

  <!-- Portal Requests Tab -->
  <div v-if="activeVoiceTab === 'requests'">
    <PortalRequest/>
  </div>

  <!-- Documents Tab -->
  <div v-if="activeVoiceTab === 'documents'">
   <DocumentApproval/>
  </div>

  <!-- Warehouse Tab -->
  <div v-if="activeVoiceTab === 'warehouse'">
     <DocumentWarehouse/>
  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="all_portals" aria-labelledby="all_portals_label">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <ul class="nav nav-pills publish-tabs justify-content-center" role="tablist">
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'your_feed' }"
          @click="activeVoiceTab = 'your_feed'">
          News & Articles
        </button>
      </li>
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'voice' }"
          @click="activeVoiceTab = 'voice'">
          Voice
        </button>
      </li>
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'requests' }"
          @click="activeVoiceTab = 'requests'">
          Requests
        </button>
      </li>
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'documents' }"
          @click="activeVoiceTab = 'documents'">
          Document/Media Approval
        </button>
      </li>
      <li class="nav-item text-center ms-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          :class="{ active: activeVoiceTab === 'warehouse' }"
          @click="activeVoiceTab = 'warehouse'">
          Document Warehouse
        </button>
      </li>
    </ul>
  </div>
</div>

<ReportCommentModal v-if="comment_modal_visible" :report_data="report_data"
  @hide_comment_comment="hide_comment_comment" />

 <StickyNav/> 
